import React from 'react'

/*
Button types: 

close-top           -   Trapeze-shaped close button with the long side on the top
close-bottom        -   Trapeze-shaped close button with the long side on the bottom
hover-top-left      -   Button w/ cut corner on the top left   
hover-bottom-left   -   Button w/ cut corner on the bottom left
*/

class Button extends React.Component {

    //Converts propsgiven function to "safe" functions (prevents calls of undefined functions)
    getSafeFunction = (props) => {
        return props ? props : (event) => {event.stopPropagation()}
    }

    getButton = (type) => {
        let cornerPos
        switch (type) {
            case "close-top":
            case "close-bottom":
                return (
                    <div
                        className={"ci-btn-close ci-btn-" + type}
                        onClick={this.getSafeFunction(this.props.onClick)}
                        onMouseEnter={this.getSafeFunction(this.props.onMouseEnter)}
                        onMouseLeave={this.getSafeFunction(this.props.onMouseLeave)}
                        onMouseOver={this.getSafeFunction(this.props.onMouseOver)}
                    >
                        <button className="ci-btn-close-content">{this.props.children ? this.props.children : "Schliessen"}</button>
                    </div>
                )
            case "hover-top-left":
                cornerPos = type.slice(6).split('-')
                return (
                    <div
                        className="ci-btn ci-btn-styleguide"
                        onClick={this.getSafeFunction(this.props.onClick)}
                        onMouseEnter={this.getSafeFunction(this.props.onMouseEnter)}
                        onMouseLeave={this.getSafeFunction(this.props.onMouseLeave)}
                        onMouseOver={this.getSafeFunction(this.props.onMouseOver)}
                    >
                        <span className={"ci-btn-hover ci-btn-" + type}>
                            <a className={"btn ci-btn-" + cornerPos[1] + "-" + cornerPos[0]} style={{ color: "#FFFFFF" }} type="">{this.props.children}</a>
                        </span>
                    </div>
                )
            case "hover-bottom-left":
                cornerPos = type.slice(6).split('-')
                return (
                    <div
                        className={"ci-btn ci-btn-styleguide"  + (this.props.disabled ? " ci-btn-disabled" : "")}
                        onClick={this.props.disabled ? () => { return; } : this.getSafeFunction(this.props.onClick)}
                        onMouseEnter={this.getSafeFunction(this.props.onMouseEnter)}
                        onMouseLeave={this.getSafeFunction(this.props.onMouseLeave)}
                        onMouseOver={this.getSafeFunction(this.props.onMouseOver)}
                    >
                        <span className={this.props.disabled ? "" : "ci-btn-hover ci-btn-" + type}>
                            <a className={"btn ci-btn-" + cornerPos[0] + "-" + cornerPos[1] + (this.props.disabled ? " disabled" : "")} style={{ color: "#FFFFFF" }} type="">{this.props.children}</a>
                        </span>
                    </div>
                )
            default:
                return (
                    <div
                        className="ci-btn ci-btn-styleguide"
                        onClick={this.getSafeFunction(this.props.onClick)}
                        onMouseEnter={this.getSafeFunction(this.props.onMouseEnter)}
                        onMouseLeave={this.getSafeFunction(this.props.onMouseLeave)}
                        onMouseOver={this.getSafeFunction(this.props.onMouseOver)}
                    >
                        <span className="ci-btn-hover ci-btn-hover-bottom-left">
                            <a className={"btn ci-btn-left-top"} style={{ color: "#FFFFFF" }} type="">{this.props.children}</a>
                        </span>
                    </div>
                )
        }
    }

    render() {
        return(
            <span>
                {this.getButton(this.props.type)}
            </span>
        )
    }
}

export default Button

